"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Grid =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Grid, _PureComponent);

  function Grid() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        _this$props$width = _this$props.width,
        width = _this$props$width === void 0 ? 1 : _this$props$width,
        offset = _this$props.offset,
        responsive = _this$props.responsive,
        stretch = _this$props.stretch,
        children = _this$props.children,
        gutter = _this$props.gutter,
        other = _objectWithoutPropertiesLoose(_this$props, ["width", "offset", "responsive", "stretch", "children", "gutter"]);

    var autoCount = 0;
    var settleWidth = 0;

    _react.Children.toArray(children).forEach(function (child) {
      if (child.type && child.type.isGrid) {
        if (child.props.width) settleWidth += child.props.width;else autoCount += 1;
      }
    });

    var autoWidth = autoCount > 0 ? (1 - settleWidth) / autoCount : 0;
    var className = (0, _classnames.default)(this.props.className, (0, _utils.getGrid)({
      width: width,
      offset: offset,
      responsive: responsive
    }));
    var style = Object.assign({}, this.props.style);

    if (gutter && gutter > 0) {
      style.width = 'auto';
      style.display = 'block';
      style.marginLeft = 0 - gutter / 2 + "px";
      style.marginRight = 0 - gutter / 2 + "px";
    }

    return _react.default.createElement("div", _extends({}, other, {
      style: style,
      className: className
    }), _react.Children.toArray(children).map(function (child) {
      if (child.type && child.type.isGrid) {
        var pps = {
          style: Object.assign({}, child.props.style)
        };
        if (!child.props.width) pps.width = autoWidth;
        if (stretch) pps.style = _objectSpread({}, pps.style, {
          minHeight: '100%',
          height: '100%'
        });

        if (gutter && gutter > 0) {
          pps.style = _objectSpread({}, pps.style, {
            paddingLeft: gutter / 2,
            paddingRight: gutter / 2
          });
        }

        return (0, _react.cloneElement)(child, pps);
      }

      return child;
    }));
  };

  return Grid;
}(_react.PureComponent);

exports.default = Grid;

_defineProperty(Grid, "isGrid", true);

_defineProperty(Grid, "displayName", 'ShineoutGrid');

_defineProperty(Grid, "propTypes", {
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  gutter: _propTypes.default.number,
  offset: _propTypes.default.number,
  responsive: _propTypes.default.string,
  stretch: _propTypes.default.bool,
  style: _propTypes.default.object,
  width: _propTypes.default.number
});